import styled from 'styled-components';

export const ClassButton = styled.button`
font-family: Outfit;
font-size: 16px;
font-weight: 500;
background-color: #c0b3d6;
color: white;
height: 48px;
width: 365px;
border: none;
border-radius: 20px;
margin-top: 10px;
cursor: pointer;

:focus {
    background-color: #8c78af;
}

@media (max-width: 400px) {
      width: 290px;
     }
`